<template>

<div class="row flex">
  <div
      class="col col-xxs-6 col-xs-6 col-sm-3 col-md-3"
      :key="index"
      v-for="(category, index) in createplusCategories"
  >
    <a v-on:click="clickLink(category.categoryID)">
      <div class="createTiles-topImageItem pointer_bt">
        <img
          :src="app_root + '/assets/createplus/img/category/thumbnail/' + category.categoryID + '.jpg'"
          class="img-responsive center-block"
        />
      </div>
    </a>

    <a v-on:click="clickLink(category.categoryID)">
      <div class="createTiles-panelTitle pointer_bt">
        <CreateplusMessage 
            fcontId="1" 
            v-bind:flinkId="category.categoryNumber.toString()"
            msgkey="1"
            v-bind:defaultValue="category.categoryID" />
      </div>
    </a>

</div>

</div>
<!-- row flex -->
</template>

<script>
import { mapState, mapGetters } from "vuex";
import CreateplusMessage from "./CreateplusMessage";

export default {
  name: "CreatePlusCategoryTiles",
  props: {
    createplusCategories: Array,
  },
  components: {
    CreateplusMessage,
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT,
    };
  },
  computed: {
    ...mapState(["setupnavi", "languageChangeCount", "lg2"]),
    ...mapGetters(["isBuiltInApp"]),
    ...mapGetters('createplusTemplates', ["getSortSubCategories"]),
  },
  methods: {
    clickLink: function (categoryid) {
      this.$gtag.event("select_content", {
        "content_type": "category",
        "item_category": categoryid,
        "location_id": "create_top",
        "site_id": "create"
      })
      
      let subCategories = this.getSortSubCategories(categoryid)
      const subcategoryid = subCategories[0].subCategoryID;
      if (this.isBuiltInApp) {
        this.$router.push({
          path:
            "/createplus/" +
            this.lg2 +
            "/app/templates/" +
            categoryid +
            "/" +
            subcategoryid,
          query:
           { EXE: this.$route.query.EXE, LOG: this.$route.query.LOG, locale: this.$route.query.locale }  
        });
      }else {
        this.$router.push({
          path:
            "/createplus/" +
            this.lg2 +
            "/templates/" +
            categoryid +
            "/" +
            subcategoryid,
          query:
            { EXE: this.$route.query.EXE, locale: this.$route.query.locale }  
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.flex {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
}

.flex::before,
.row::after {
  display: none;
}

.flex .col {
  padding-bottom: 20px;
}

.thumbnail {
  height: 100%;
  margin-bottom: 0px;
}

@media (max-width: 767px) {
  .flex .col {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
  }
}
</style>